/* eslint-disable */
import React, { useState } from 'react';
import { useForm, Controller, SubmitHandler } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import Container from '@material-ui/core/Container';

// import Copyright from 'components/Copyright';
// import logo from 'assets/logo.png';
import { verifyAccountValidationSchema as validationSchema } from 'containers/shared/validationSchemas';

import useStyles from './ResetPassword.style';

export type VerifyAccountFormValues = {
  email: string;
};

const defaultValues: VerifyAccountFormValues = {
  email: '',
};

const VerifyAccount: React.FC = () => {
  // const classes = useStyles();

  // const {
  // handleSubmit,
  // control,
  // formState: { errors, isValid, touchedFields },
  // } = useForm<VerifyAccountFormValues>({
  // mode: 'onTouched',
  // defaultValues,
  // resolver: yupResolver(validationSchema),
  // });

  return null;
};

export default VerifyAccount;
